'use client';

import { HomeEnIcon } from '@/components/icons/svg-icons';
import { scoreboardService } from '@/services/scoreboard.service';
import { SportMatchModel } from '@nf/types/odds';
import { TopbarTeamDot } from '@/features/single-match/top-bar/top-bar-team-dot';
import { MatchTimer } from './match-timer';
import { useTranslations } from 'next-intl';
import { TopbarMatchListDropdownButton } from '@/features/single-match/top-bar/top-bar-match-list-dropdown-button';

interface MatchOtherProps {
	match: SportMatchModel;
	home: string;
	away: string
	isAsideLayout: boolean;
	isListOpen: boolean;
	handleListOpen: () => void;
}

export const MatchOther = ({
	match,
	home,
	away,
	isAsideLayout,
	isListOpen,
	handleListOpen
}: MatchOtherProps) => {
	const scoreList = scoreboardService.getAllSportScore(match)[0]?.text.split('-');
	const t = useTranslations('General');
	return (
		<div className="single-topbar__match" 
			onClick={handleListOpen}
		>
			<div className="single-topbar__col">
				<HomeEnIcon />
				<span className="team-name">
					{home}
				</span>
				{
					match.GameID === 44 ?
						<TopbarTeamDot variant={'red'} /> : null
				}
			</div>
			<div className="team-vs">
				<div className="team-vs__score">
					{
						scoreList ? (
							scoreList.length > 1 ?
								(
									<>
										<span>{scoreList[0]}</span>
										-
										<span>{scoreList[1]}</span>
									</>
								) : <div className="team-vs__round">{`${t('lbl_round')}${scoreList[0]}`}</div>
						) : null
					}
				</div>
				<div className="team-vs__status">
					<div className="match-timer">
						<MatchTimer match={match} />
					</div>
				</div>
			</div>
			<div className="single-topbar__col">
				{
					match.GameID === 44 ?
						<TopbarTeamDot variant={'blue'} /> : null
				}
				<span className="team-name">
					{away}
				</span>
				<TopbarMatchListDropdownButton
					isListOpen={isListOpen}
					isLive={match.IsLive}
					isAsideLayout={isAsideLayout}
				/>
			</div>
		</div>
	)
}